import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { deviceService, licenseService } from '../../_services'
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from 'react-bootstrap'
import styles from './details.module.css';
import moment from 'moment'

function DeviceDetails() {

	const {uuid} = useParams()
	const [licenses, setLicenses] = useState([])
	const [device, setDevice] = useState(null)
	const {t} = useTranslation('common')

	useEffect(() => {
		licenseService.simpleList().then(licenses => {
			setLicenses(licenses)

            deviceService.get(uuid).then(device => {
				setDevice(device)
		    })
        })
	}, [])

	const formatDate = (cell) => {
		return moment(cell).format('YYYY-MM-DD HH:mm:ss')
	}

	const formatBoolean = (cell) => {
		return cell ? t('crudtable.yes') : t('crudtable.no')
	}

	const formatSize = function(cell, row) {
	    if (cell) {
			var i = Math.floor( Math.log(cell) / Math.log(1000) );
	        return ( cell / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
	    }
	    return 0
    }

	return (
		<Container className={styles.deviceDetails}>
			<h2>
				{uuid}
			</h2>
			{ licenses.length > 0 && device &&
				<Row>
					<Col md={{ span: 6, offset: 0 }}>
						<div>
		                    <label>
		                        {t('device.columns.id')}
		                    </label>
		                    { device.id || '-' }
	                    </div>
						<div>
		                    <label>
		                        {t('device.columns.datecreated')}
		                    </label>
		                    { device.dateCreated ? formatDate(device.dateCreated) : '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.lastupdated')}
		                    </label>
		                    { device.lastUpdated ? formatDate(device.lastUpdated) : '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.username')}
		                    </label>
		                    { device.username || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.osversion')}
		                    </label>
		                    { device.osVersion || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.phonemodel')}
		                    </label>
		                    { device.phoneModel || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.appversion')}
		                    </label>
		                    { device.appVersion || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.deletephotosafterupload')}
		                    </label>
		                    {formatBoolean(device.deletePhotosAfterUpload)}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.backuptolibrary')}
		                    </label>
		                    {formatBoolean(device.backupToLibrary)}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.uploadonwifionly')}
		                    </label>
		                    {formatBoolean(device.uploadOnWifiOnly)}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.darkmode')}
		                    </label>
		                    { device.darkMode != null ? formatBoolean(device.darkMode) : '-'}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.availablestoragespace')}
		                    </label>
		                    {device.availableStorageSpace != null ? formatSize(device.availableStorageSpace) : '-'}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.currentlicense')}
		                    </label>
		                    { licenses.map(license => {
		                        if (license.id == device.currentLicenseId) {
		                            return <div key={license.id}>
			                            {license.name ? license.name + ' (' + license.licenseCode + ')' : license.licenseCode}
			                        </div>
		                        }
		                        return <div key={license.id}></div>
		                    })}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.licenses')}
		                    </label>
		                    <ul>
			                    { device.licenses.map(licenseId => {
			                        var license = licenses.find(license => license.id === licenseId)
			                        return <li key={licenseId}>
			                            {license.name ? license.name + ' (' + license.licenseCode + ')' : license.licenseCode}
			                        </li>
			                    })}
		                    </ul>
	                    </div>
					</Col>
				</Row>
			}
		</Container>
	)
}

export default DeviceDetails;